import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Link from '../Link';

function linkCheck(link) {
  if (link && (link === 'careers' || link === 'about')) {
    link = `${process.env.REACT_APP_CLIENT_FENDER_COM}/${link}`; // eslint-disable-line no-param-reassign
  }
  return link;
}
class FooterLinkColumn extends PureComponent {
  render() {
    const { columnTitle, columnLinks } = this.props;
    const trackEvent = {
      eventType: 'Click Footer Navigation',
      properties: {
        navigationFooter: '',
      },
    };
    return (
      <div className="footer-link-column">
        <h6 className="ttu ma0 mb2 f6">{columnTitle}</h6>
        <ul className="list mt0 mb4 pa0" data-id={`footer-link-column-${columnTitle}`}>
          {columnLinks.map(item => (
            <li key={`footer-link-item-${item.attributes.title}`} className="mb2">
              <Link
                className="mid-gray f6 source-sans"
                to={linkCheck(item.attributes.url)}
                trackEvent={{
                  ...trackEvent,
                  properties: { navigationFooter: item.attributes.title },
                }}
                dataId={`footer-link-${item.attributes.title}`}
              >
                {item.attributes.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

FooterLinkColumn.propTypes = {
  columnLinks: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        order: PropTypes.number.isRequired,
        group: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        'is-external-url': PropTypes.bool.isRequired,
        url: PropTypes.string.isRequired,
      }),
    }),
  ),
  columnTitle: PropTypes.string,
};

FooterLinkColumn.defaultProps = {
  columnLinks: [],
  columnTitle: '',
};

export default FooterLinkColumn;
